document.addEventListener('DOMContentLoaded', function () {
    const accordionButtons = document.querySelectorAll('.accordion-button');

    accordionButtons.forEach(button => {
        button.addEventListener('click', function () {
            const content = this.nextElementSibling;
            content.classList.toggle('show');

            const icon = this.querySelector('.icon');
            icon.textContent = icon.textContent === '+' ? '-' : '+';
        });

        if (button.textContent.includes('Dimensions and Details')) {
            button.click();
        }
    });

    removeSelectClass();
});

function saveRecentlyViewed( productItem ) {
    if ( productItem.tags.includes('is_advert') ) return;

    const productData = {
        productTitle: productItem.title || '',
        productImg: productItem.image || '',
        productPrice: productItem.price || '',
        productCompareAtPrice: productItem.compare_at_price  || '',
        productUrl: productItem.url || '',
        productID: productItem.product_id || '',
        productVariantID: productItem.product_variant_id || '',
        productTags: productItem.tags || '',
        productAvailability: productItem.available || '',
        objectID: productItem.objectID || '',
        queryId: productItem.queryId || '',
        position: productItem.position || '',
        hasFreeFurnitureCover: productItem.has_freefurniturecover || '',
        hasFreeGift: productItem.has_freegift || '',
        usp1: productItem.usp1 || '', 
        usp2: productItem.usp2 || '',
        usp3: productItem.usp3 || '', 
        averageRating: productItem.average_rating || '',
        reviewsCount: productItem.reviews_count || '',
        parasolHandles: productItem.parasol_handles || '',
        hasParasolDate: productItem.has_parasol_date || '',
        color_swatches_cache: productItem.color_swatches_cache || ''
      };

      if (productData.productTitle && productData.productImg) {
        let existingData = JSON.parse(localStorage.getItem('recently_viewed_items')) || [];
        const existingIndex = existingData.findIndex(item => item.productTitle === productData.productTitle);
        const isCurrentProduct = existingIndex !== -1 && existingIndex === 0;

        if (existingIndex !== -1 && !isCurrentProduct) {
          existingData.splice(existingIndex, 1);
        }
        if (!isCurrentProduct) {
          existingData.unshift(productData);
        }
        localStorage.setItem('recently_viewed_items', JSON.stringify(existingData));
      }
}

function algoliaClickedEvent(eventName, objectIDs, queryID = null, position = null, index = `${algoliaShopify.config.index_prefix}products`) {
    window.aa('init', {
      appId: algoliaShopify.config.app_id,
      apiKey: algoliaShopify.config.search_api_key,
    });

    if (queryID && position !== null) {
        window.aa("clickedObjectIDsAfterSearch", {
            eventName: eventName,
            index: index,
            queryID: queryID,
            objectIDs: objectIDs,
            positions: [Number(position)],
        });
    } else {
        window.aa('clickedObjectIDs', {
          index: index,
          eventName: eventName,
          objectIDs: objectIDs, 
        });
    }
  
}

const trackSearchAttribution = (query_id, variant_id, product_id) => {
    const clickData = {
        eventName: 'Added to cart',
        index: `${algoliaShopify.config.index_prefix}products`,
        queryID: query_id,
        objectIDs: [variant_id],
        productId: product_id,
    };

    try {
        const localStorageKey = 'algolia_analytics_clicked_objects'; // Key

        // Get any data previously stored
        const previousClickItemsString =
            localStorage.getItem(localStorageKey) || '[]';
        const previousClickItems = JSON.parse(previousClickItemsString);

        // Add the current products data to local storage
        previousClickItems.push(clickData);
        localStorage.setItem(localStorageKey, JSON.stringify(previousClickItems));
    } catch (error) {
        console.error(error);
    }
}

function removeSelectClass() {
    const screenWidth = window.innerWidth;
    const divElements = document.querySelectorAll('.footer-block__heading.inline-richtext');

    divElements.forEach(function (divElement) {
        if (screenWidth > 580) {
            divElement.classList.remove('accordion-button');
        } else {
            divElement.classList.add('accordion-button');
        }
    });
}

function preventVerticalScrolling(event) {
    const carousel = $(event.target); // Get the carousel element
    
    let initialTouchX = 0;
    let initialTouchY = 0;

    // Detect the initial touch position
    carousel.on("touchstart", function (e) {
      const touch = e.originalEvent.touches[0];
      initialTouchX = touch.pageX;
      initialTouchY = touch.pageY;
    }, {passive: true});

    // Prevent vertical scrolling when dragging horizontally
    carousel.on("touchmove", function (e) {
      const touch = e.originalEvent.touches[0];
      const movementX = touch.pageX - initialTouchX; // Horizontal movement
      const movementY = touch.pageY - initialTouchY; // Vertical movement

      // Determine if horizontal movement is significantly greater than vertical movement
      const horizontalDominanceThreshold = 4; // Adjust threshold as needed

      if (Math.abs(movementX) * horizontalDominanceThreshold > Math.abs(movementY)) {
        e.preventDefault(); // Prevent scrolling if horizontal motion is clearly dominant
      }
    }, {passive: true});
  }

window.addEventListener('resize', removeSelectClass);

function getDeviceType() {
    const width = window.innerWidth;

    if (width <= 767) {
        return 2;

    } else if (width >= 768 && width <= 1024) {
        return 4;
    } else {
        return 5;
    }
}

function showOrderSwatchesBtn () {
    const tempSelectedSwatchArr = JSON.parse(localStorage.getItem("_temp_free_sample")) || [];

    if ( tempSelectedSwatchArr.length > 0 ) {
        $('.add_swatches').show();
    } else {
        $('.add_swatches').hide();
    }
}

function toggleInfoModal(modalId) {
    $(`#openInfo${modalId}`).on('click', function (event) {
        event.stopPropagation();
        $(`#info_modal${modalId}`).show();
    });

    $(`#info_modal_close${modalId}`).on('click', function () {
        $(`#info_modal${modalId}`).hide();
    });

    $(document).on('click', function(event) {
        if (!$(event.target).closest(`#info_modal${modalId}`).length && !$(event.target).is(`#openInfo${modalId}`)) {
            $(`#info_modal${modalId}`).hide();
        }
    });
}

toggleInfoModal(1);
toggleInfoModal(2);
toggleInfoModal(3);

function scrollToTarget(target, offsetY) {
 
    if ($(target).length == 0 || !offsetY) return;
    //check if native smooth scrolling can be used
    const preferReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const browserSupport = 'scrollBehavior' in document.documentElement.style;
    const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
 
    if ($(window).width() < 768) { // Check if mobile device
        offsetY = offsetY + 16;
    }
 
    if (browserSupport && !preferReducedMotion && !isFirefox){
        const element = typeof target === 'string' 
            ? document.querySelector(target) 
            : target;
 
        // Early return if no valid element
        if (!element) return;
 
        const targetPosition = element.getBoundingClientRect().top + 
                                window.pageYOffset - 
                                offsetY;
 
        // Safe scrolling with native smooth scroll
        window.scrollTo({
            top: Math.min(
                Math.max(targetPosition, 0), 
                document.documentElement.scrollHeight - window.innerHeight
            ),
            behavior: 'smooth'
        });
    }else{
        $('html, body').animate({
            scrollTop: $(target).offset().top - offsetY
        }, 1000);
    }
}

$("#buttonreview, .reviews-count").on('click', function (e) {
    e.preventDefault();
    const target = window.location.hostname.includes('.co.uk') ? '#description-accordions' : '#judgeme_product_reviews'
    scrollToTarget(target, $('sticky-header').height());
});

$("#buttondims").on('click', function (e) {
    e.preventDefault();
    scrollToTarget("#dims", $('sticky-header').height());
});

$(document).on('click', ".product-details__container[data-title='reviews']:not(.no-reviews), .product__title .rating-container, .product__title-container .rating-container", function (e) {
    e.preventDefault();
    const target = Shopify?.shop == 'laura-james-furniture.myshopify.com' ? '#description-accordions' : '#judgeme_product_reviews'
    scrollToTarget(target, $('sticky-header').height());
});

$('body').on('click', '.complementary-card__add-to-cart-mobile', function(e) {
    e.preventDefault();

    const { productId, productTitle, productImage, productPrice, productComparePrice } = $(this).data();

    $('.quick-add-modal').css({ display: 'grid' })
    $('.quick-add-modal__product-title').text(productTitle)
    $('.quick-add-modal__product-img').attr('src', productImage)
    $('.quick-add-modal quick-add-to-cart input[name=id]').val(productId)
    $('.quick-add-modal__product-price').html(`
        ${ productComparePrice ? `<span><s>${productComparePrice}</s></span>` : '' } 
        <span class="sale-price">${productPrice}</span>
    `)

})

$('body').on('click', '.quick-add-modal__close', function() {
    $('.quick-add-modal').hide()
})

$('body').on('click', '.shop-collection-products', function() {
    const { item_name, image_url, price, compare_at_price, product_handle, item_id, tags, available } =  $(this).data()

    const productItem = {
        product_id: item_id,
        title: item_name,
        image: image_url,
        price: price,
        compare_at_price: compare_at_price,
        url: product_handle,
        tags: tags,
        available: available,
    };

    if( item_id ){
      saveRecentlyViewed(productItem)
    }
})

$(document).ready(function () {
    if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
        document.documentElement.className += ' ios';
    }

    if ( window.setupRelatedProducts )  {
        setupRelatedProducts(); 
    }
});

(function ($) {
    const freeSample = {
      _cartList: '.free-sample-btn, .close-btn, .drawer_overlay',
      _orderFreeSample: '.add_swatches',
      _drawerOverlay: '.drawer_overlay',

      init: function () {
          this.initializedConstantVariable();
          this.handleFreeSampleDrawer();
          this.handleFreeSampleSelection();
          this.handleFreeSampleActions();
          this.handleDocumentReady();
      },

      initializedConstantVariable: function () {
          window.ENABLE_STATE = {
              cursor: 'pointer',
              opacity: '1',
              pointerEvents: 'auto'
          };

          window.DISABLE_STATE = {
              cursor: 'not-allowed',
              opacity: '.3',
              pointerEvents: 'none'
          };

          window.LOADING_CLASS = 'btn--loading';
          window.SWATCH_SLOT = parseInt($('.selected-swatches').data('swatch-count') || 0);
      },

      handleFreeSampleDrawer: function () {
        $(document).on('click', this._cartList, function (e) {
            e.preventDefault();
            const drawerWidth = document.querySelector('.cart-drawer').offsetWidth;

            if ($(this).is('.free-sample-btn')) fetchFreeSample(id = null, action = 'open');

            const isDrawerOpen = $('.drawer_overlay').hasClass('active');

            if ($(this).is('.drawer_overlay')) {
                $(this._cartList).not('.drawer_overlay').removeClass('active');
            } else {
                $(this).toggleClass('active');
            }

            $('.drawer_overlay').toggleClass('active');
            $('.cart-drawer-push').toggleClass('cart-drawer-pushtoleft');
            $('.cart-drawer-right').toggleClass('cart-drawer-open');
            $('body').toggleClass('js-drawer-open');

            const functionChangeHeaderZIndex = () => {
                $('body .shopify-section-header-sticky, .shopify-section-group-header-group').toggleClass('swatches-drawer-open');

            }

            checkFreeSample();

            if (isDrawerOpen) {
                moveZendeskButton();
                localStorage.removeItem("_temp_free_sample");
                populateFreeSample();
                enableBodyOverScroll();
            } else {
                moveZendeskButton(drawerWidth);
                disableBodyOverScroll();
            }

            functionChangeHeaderZIndex();
        });

          document.addEventListener('keydown', function (e) {
              if (e.keyCode === 27) {
                  if ($('.drawer_overlay').hasClass('active')) {
                      $('.drawer_overlay').toggleClass('active');
                      $('.cart-drawer-push').toggleClass('cart-drawer-pushtoleft');
                      $('.cart-drawer-right').toggleClass('cart-drawer-open');
                      $('body').toggleClass('js-drawer-open');
                      checkFreeSample();
                      moveZendeskButton();
                      localStorage.removeItem("_temp_free_sample");
                      populateFreeSample();
                      functionChangeHeaderZIndex();
                  }
              }
          });
      },

      handleFreeSampleSelection: function () {
          localStorage.removeItem("_temp_free_sample");
          // Use event delegation to handle dynamically added checkboxes
          $(document).on('change', "input:checkbox[name=swatches]", function (e) {
              e.preventDefault();
              let selectedSwatchArr = JSON.parse(localStorage.getItem("_temp_free_sample") || '[]');
              const SWATCH_SLOT = parseInt($('.selected-swatches').data('swatch-count') || 0);

              if (selectedSwatchArr.length < SWATCH_SLOT) {
                  if (this.checked) {
                      $(this).next('.swatch-item').addClass('active');
                      $(this).attr('disabled', 'true');

                      let productInfo = {
                          title: $(this).attr("data-title"),
                          image: $(this).attr("data-img"),
                          variant_id: $(this).val(),
                          property: $(this).attr("data-property"),
                          main_product_id: $(this).attr("data-main_product_id")
                      };

                      selectedSwatchArr.push(productInfo);
                      localStorage.setItem("_temp_free_sample", JSON.stringify(selectedSwatchArr));
                      populateFreeSample();
                  }
              }

              checkFreeSample();
          });
      },

      handleFreeSampleActions: function () {
          $(document).on('click', this._orderFreeSample, function (e) {
              e.preventDefault();
              const selected = JSON.parse(localStorage.getItem("_temp_free_sample") || '[]');
              const cartCount = $('.remove-image-swatch-container._free_sample');
              const totalCount = cartCount.length;
              let addon_product = { items: [] };

              $(this).addClass(LOADING_CLASS);
              $('.alert').addClass('hidden');

              $(selected).each(function () {
                  addon_product.items.push({
                      id: this.variant_id,
                      quantity: 1,
                      properties: {
                          _type: this.property,
                          _sofa_id: this.main_product_id
                      }
                  });
              });

              if (totalCount > SWATCH_SLOT) {
                  $('.alert').removeClass('hidden');
                  $('.add_swatches').removeClass(LOADING_CLASS);
                  return;
              } else {
                  add(addon_product);
              }

              $('.swatches[type="checkbox"]').prop('checked', false);
          });

          $(document).on('click', '.remove-image-swatch-container', function () {
            const variantId = $(this).data('variant-id');
            const parentElement = $(this).parent();
            const selectedSwatchArr = JSON.parse(localStorage.getItem("_temp_free_sample")) || [];
            const newSelectedSwatchArr = selectedSwatchArr.filter(item => {
                return item.variant_id != variantId;
            })

            localStorage.setItem('_temp_free_sample', JSON.stringify(newSelectedSwatchArr));

            if (!$(this).hasClass('_temp_free_sample')) {
                $('.add_swatches').addClass(LOADING_CLASS);
                remove(variantId);
            }
            else $(`.swatch-to-show[data-swatch-variant-id="${variantId}"] .swatch-item 
            `).removeClass('active');

            $(`.swatches[value="${variantId}"]`).prop('checked', false);
            $(`.swatches[value="${variantId}"]`).removeAttr('disabled');
            $(parentElement).empty();
            $(parentElement).css('background', 'transparent');
            populateFreeSample();
            checkFreeSample();
        });
      },

      handleDocumentReady: function () {
          $('div#btn_search-target-mobile').hide();

          $('#btn_searchss_mobile').on('click', function () {
              $('#btn_search-target-mobile').css('opacity', '1');
              $('div#btn_search-target-mobile').toggle();
              $('.search-bar_input').focus();
              $('#search_modal-mobile').show();
              $('.header__middle-bar .search-bar').show();
          });

          $('.secondary_button').on('click', function () {
              $('.cart-container .cart_content').hide();
          });

          $('div#btn_search-target-desktop').hide();
          $('.search-bar_input').blur();

          $('#btn_searchss_desktop').on('click', function () {
              $('div#btn_search-target-desktop').show();
              $('.search-bar').show();
              $('div#search_modal-desktop').show();
              $('.search-bar_input').focus();
          });

          $('svg#close-desktop').on('click', function () {
              $('div#btn_search-target-desktop').hide();
              $('.search-bar_input').blur();
          });

          $('#search_modal-mobile').hide();
          $('#search-bar').hide();

          $('.icon-swatch').click(function(){
            console.log('icon watch');
            $('#btn_searchss_mobile').toggle();
            $('#close-mobile').toggle();
            });
            $('.dropdown-filters-container.yotpo-drop-down-layout').trigger("click");

            $('svg#close-mobile').on('click', function () {
                $('div#btn_search-target-mobile').hide();
            });
    
            $('#btn_searchss_mobile').on('click', function () {
                $('#btn_search-target-mobile').css('opacity', '1');
                $('div#btn_search-target-mobile').toggle();
                $('.search-bar_input').focus();
            });
    
            $('.header__icons--cart').on('click', function () {
                $('div#btn_search-target-mobile').hide();
                $('#btn_searchss_mobile').show();
                $('#close-mobile').hide();
            });
    
            $('button#mobile-menu-toggle svg').on('click', function () {
                $('div#btn_search-target-mobile').hide();
                $('#btn_searchss_mobile').show();
                $('#close-mobile').hide();
            });
    
            $('#mobile-menu-toggle').on('click', function () {
                $('#mobile-menu').addClass('active');
            });
    
            $('button.mobile-menu-toggle.mobile-menu-close').on('click', function () {
                $('#mobile-menu').removeClass('active');
            });
    
            $('#openInfo').on('click', function () {
                $('#info_modal').show();
            });
    
            $('#info_modal_close').on('click', function () {
                $('#info_modal').hide();
            });
    
            $('svg#close-desktops').on('click', function () {
                $('div#search_modal-desktop').hide();
                $('.search-bar').hide();
            });
    
            $('#btn_searchss_desktop').on('click', function () {
                $('div#btn_search-target-desktop').show();
                $('div#search_modal-desktop').show();
                $('.search-bar_input').focus();
            });
    
            $('.reviews-amount').prepend('Reviews');
    
            window.onscroll = function () {
                if (document.getElementById('mobile-menu') && !document.getElementById('mobile-menu').classList.contains('active')) {
                    headerSticky();
                }
            };
    
            const navbar = document.querySelector("header");
            const headerMenu = document.querySelector(".header-menu");
            // const sticky = navbar.offsetHeight - headerMenu.offsetHeight;
    
            function headerSticky() {
                if (window.pageYOffset >= sticky) {
                    navbar.classList.add("sticky");
    
                    if (this.oldScroll > this.scrollY) {
                        navbar.classList.add("mobile-sticky");
                    } else {
                        navbar.classList.remove("mobile-sticky");
                    }
                    this.oldScroll = this.scrollY;
                } else {
                    navbar.classList.remove("sticky");
                }
            }
    
            $('#btn_searchss_desktop').click(function () {
                $('.filters-sort').addClass('sort-spacing');
            });
    
            $('svg#close-desktop').click(function () {
                $('.filters-sort').removeClass('sort-spacing');
            });
    
            $('#btn_searchss_mobile').click(function () {
                $('.filters-sort').addClass('sort-spacing-mobile');
            });
    
            $('#close-mobile').click(function () {
                $('.filters-sort').removeClass('sort-spacing-mobile');
            });
    
            $("div#hc-psz-cnXvcA9z ").prependTo("div#description-accordions");
    
            $(window).on('load', function () {
                $('div#btn_search-target-mobile').css('opacity', '1');
                $('div#btn_search-target-desktop').css('opacity', '1');
            });
    
            if ($('#close-mobile').css('display') === 'inline') {
                $('#close-mobile').css('display', 'block');
            }
    
            var priceWrapper = $(".swatch-wrapper");
            $(".purchase-details").append(priceWrapper);
    
            $(".warranty-year p:nth-of-type(2)").append($(".more-warranty"));
            $(".free-return p:nth-of-type(2)").append($(".more-return"));
            $(".shipping-wrapper-mobile").clone().insertAfter(".sticky_atc .modal_price");
            $('h1.product_name').after($('.product-template .swatch-wrapper .yotpo'));
    
            $('#btn_searchss_mobile').on('click', function () {
                $('div#search_modal-mobile').show();
                $('div#btn_search-target-mobile').show();
            });

            $('.services-open-info-modal-js').on('click', function (e) {
                const modalId = $(e.currentTarget).data('key');
                $(`.info-modal-js[data-id="${modalId}"]`).show();
            });

            $('.info-modal-close-js').on('click', function () {
                $(this).parents('.info-modal-js').hide();
            });
        }
    }; 
    
    freeSample.init();

    (function() {
        var button = document.querySelectorAll('.button');
        var currentIndex = 0;
        var slideCount = $('.announcement__slide').length;
        var isAnimating = false;
  
        function goToSlide(index) {
          if (isAnimating) return;
  
          isAnimating = true;
  
          var targetPosition = -index * 30;
          $('.announcement__container').animate({ top: targetPosition + 'px' }, 450, function() {
            isAnimating = false;
          });
  
          currentIndex = index;
          updateButtons();
        }
  
        function updateButtons() {
          $('.button').removeClass('selected');
          $('.button:eq(' + currentIndex + ')').addClass('selected');
        }
  
        function autoplay() {
          setInterval(function() {
            var nextIndex = (currentIndex + 1) % slideCount;
            goToSlide(nextIndex);
          }, 6000);
        }

        for (var i = 0; i < button.length; i++) {
          button[i].addEventListener('click', function() {
            var index = $(this).index();
            goToSlide(index);
          }, false);
        }
  
        autoplay();
      })();
})(jQuery);